<script setup lang="ts">
import { ref, watch, computed, nextTick } from "vue";
import Editor from "@tinymce/tinymce-vue";

const props = defineProps({
	modelValue: {
		type: String,
		default: "",
	},
	config: {
		type: Object,
		default: () => {},
	},
});

const baseConfig = {
	skin: "hs",
	content_css: "hs",
};

const mergedConfig = computed(() => {
	return { ...baseConfig, ...props.config };
});

const emit = defineEmits(["update:modelValue", "initialized"]);

const content = ref("");
const handleModelValueChange = (newVal: string) => (content.value = newVal);
const handleContentChange = () => emit("update:modelValue", content.value);
const handleInitialization = (editor: any) => emit("initialized", editor);

watch(() => props.modelValue, handleModelValueChange, { immediate: true });
watch(() => content.value, handleContentChange);
</script>

<template>
	<div class="editor-wrapper">
		<Editor api-key="no-api-key" tinymce-script-src="/js/tinymce/tinymce.min.js" :init="mergedConfig" v-model="content" @init="handleInitialization" />
	</div>
</template>

<style scoped lang="sass">
.editor-wrapper
	margin-top: 24px
	min-height: 162px

	textarea
		display: none
</style>
